/**
 *
 * MsDynamicsVerify
 *
 */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import { makeSelectIsVerify, makeSelectError } from './selectors';
import { verifyMsDynamics } from './actions';
import reducer from './reducer';
import saga from './saga';
import logo from 'assets/img/brand/logo-full.png';
import queryString from 'query-string';
import triggerNotification from 'utils/triggerNotification';
import { NOTIFICATION } from 'common/constants';
import { INTEGRATION_PAGE } from 'common/strings';
import {
  VerifyContainer,
  VerifyContent,
  VerifyHeaderWrapper,
  VerifyDivider,
  VerifyLogo,
} from './styled';

const MsDynamicsVerify = ({
  verifyMsDynamicsStart,
  isVerify,
  error,
  location,
  verifyMsDynamicsError,
}) => {
  useInjectReducer({ key: 'msDynamicsVerify', reducer });
  useInjectSaga({ key: 'msDynamicsVerify', saga });

  const verifyCode = queryString.parse(location.search)?.code;
  const verifyStatus = queryString.parse(location.search)?.status;

  useEffect(() => {
    if (parseInt(verifyCode) === 200 && verifyStatus) {
      verifyMsDynamicsStart();
    } else {
      const error = {
        error: verifyStatus,
      };
      verifyMsDynamicsError({ error });
      triggerNotification({
        title: INTEGRATION_PAGE.ALERTS.MSDYNAMICS_ERROR,
        type: NOTIFICATION.TYPE.ERROR,
      });
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Helmet>
        <title>Zoominfo Chat | Microsoft Dynamics CRM</title>
        <meta name="description" content="Description of MsDynamicsVerify" />
      </Helmet>
      <VerifyContainer>
        <div className="d-flex justify-content-center p-5">
          <VerifyLogo src={logo} alt="zoominfo chat logo" />
        </div>
        <VerifyContent>
          {isVerify ? (
            <>
              <VerifyHeaderWrapper>Pending</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Verification Pending</p>
            </>
          ) : error ? (
            <>
              <VerifyHeaderWrapper>Failed</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Something went wrong while connecting Microsoft Dynamics CRM with ZoomInfo Chat</p>
            </>
          ) : (
            <>
              <VerifyHeaderWrapper>Successful</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Successfully connected your Microsoft Dynamics CRM Account with ZoomInfo Chat</p>
            </>
          )}
        </VerifyContent>
      </VerifyContainer>
    </>
  );
};

MsDynamicsVerify.propTypes = {
  verifyMsDynamicsStart: PropTypes.func,
  isVerify: PropTypes.bool,
  error: PropTypes.bool,
};

export const mapStateToProps = (state, props) => {
  return createStructuredSelector({
    isVerify: makeSelectIsVerify(),
    error: makeSelectError(),
  });
};

export const mapDispatchToProps = dispatch => {
  return {
    verifyMsDynamicsStart: () => dispatch(verifyMsDynamics.start()),
    verifyMsDynamicsError: ({ error }) => dispatch(verifyMsDynamics.error({ error })),
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withRouter, withConnect)(MsDynamicsVerify);
